export function setTitle(title: string): void {
	window.document.title = `QRIP CRM • ${title}`;
}
